import 'react-datepicker/dist/react-datepicker.css';
import C from '../../ivy/Resume/Resume.module.scss';
import S from '../../common/SelectDateBox/SelectDateBox.module.scss';
import '../../../styles/customCalendar.scss';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { ko } from 'date-fns/esm/locale';
import { getYear } from 'date-fns';
import { forwardRef, MouseEventHandler, useState } from 'react';
import calIcon from '../../ivy/Resume/assets/calendarIcon.svg';
import { CalendarType } from '../../../types/EducationTypes';
import _ from 'lodash';

interface SelectDateBoxProps {
  selectedDate: Date | null;
  setSelectedDate: Function;
  type: CalendarType;
  index?: number;
}

const SelectDateBox = (props: SelectDateBoxProps) => {
  const { selectedDate, setSelectedDate, type, index } = props;
  const findPlaceHolderByType = (type: CalendarType) => {
    switch (type) {
      case 'education-entrance-date':
        return '입학년월(YYYY-MM)';
      case 'education-graduation-date':
        return '졸업년월(YYYY-MM)';
      case 'external-activity-start-date':
        return '시작기간(YYYY-MM)';
      case 'external-activity-end-date':
        return '종료기간(YYYY-MM)';
      case 'career-start-date':
        return '입사년월(YYYY-MM)';
      case 'career-end-date':
        return '퇴사년월(YYYY-MM)';
      case 'certificate-at-date':
        return '취득/응시일(YYYY-MM-DD)';
      case 'award-at-date':
        return '수상일(YYYY-MM-DD)';
      case 'language-test-at-date':
        return '취득/응시일(YYYY-MM-DD)';
      case 'birth-day':
        return 'YYYY-MM-DD';
      case 'military-start-date':
        return '복무시작연월(YYYY-MM)';
      case 'military-end-date':
        return '복무종료연월(YYYY-MM)';
      default:
        return '날짜선택';
    }
  };

  const isShowDayMonthYear = () => {
    return ['birth-day', 'certificate-at-date', 'award-at-date', 'language-test-at-date'].includes(
      type,
    );
  };

  // 캘린더 인풋 커스텀
  const CalCustomInput = forwardRef(
    ({ value, type, onClick }: { value: any; type: CalendarType; onClick: any }, ref) => (
      <>
        <input
          type="text"
          className="input-text input-border"
          onClick={onClick}
          value={value === null ? '' : value}
          readOnly
          placeholder={findPlaceHolderByType(type)}
        />
        <div className="cal-icon" onClick={onClick}>
          <img src={calIcon} alt="달력" />
        </div>
      </>
    ),
  );

  return (
    <div className={`react-datepicker ${C.resume_period_date}`}>
      {isShowDayMonthYear() ? (
        <>
          {/* YYYY-MM-DD */}
          <DatePicker
            className="date_picker"
            calendarClassName={S.calender_wrapper}
            locale={ko}
            dateFormat="yyyy.MM.dd" // 날짜 형태
            shouldCloseOnSelect // 날짜를 선택하면 datepicker가 자동으로 닫힘
            showYearDropdown
            minDate={new Date('1900-01-01')} // minDate 이전 날짜 선택 불가
            maxDate={new Date()} // maxDate 이후 날짜 선택 불가
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            dateFormatCalendar="MMMM"
            onChange={(date) => setSelectedDate(date, index)}
            selected={selectedDate}
            customInput={
              <CalCustomInput value="selectedEnterDate" type={type} onClick={() => {}} />
            }
          />
        </>
      ) : (
        <>
          {/* YYYY-MM */}
          <DatePicker
            locale={ko}
            dateFormat="yyyy.MM" // 날짜 형태
            dateFormatCalendar="MMMM"
            shouldCloseOnSelect // 날짜를 선택하면 datepicker가 자동으로 닫힘
            minDate={new Date('1900-01-01')} // minDate 이전 날짜 선택 불가
            maxDate={new Date()} // maxDate 이후 날짜 선택 불가
            yearDropdownItemNumber={100}
            showMonthYearPicker
            onChange={(date) => setSelectedDate(date, index)}
            selected={selectedDate}
            customInput={
              <CalCustomInput value="selectedEnterDate" type={type} onClick={() => {}} />
            }
            renderCustomHeader={({
              date,
              changeYear,
              decreaseYear,
              increaseYear,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <CustomHeader
                date={date}
                changeYear={changeYear}
                decreaseYear={decreaseYear}
                increaseYear={increaseYear}
                prevMonthButtonDisabled={prevMonthButtonDisabled}
                nextMonthButtonDisabled={nextMonthButtonDisabled}
              />
            )}
          />
        </>
      )}
    </div>
  );
};

export default SelectDateBox;

interface CustomHeaderProps {
  date: Date;
  changeYear: Function;
  decreaseYear: MouseEventHandler<HTMLButtonElement>;
  increaseYear: MouseEventHandler<HTMLButtonElement>;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
}

function CustomHeader(props: CustomHeaderProps) {
  const {
    date,
    changeYear,
    decreaseYear,
    increaseYear,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  } = props;

  const [isShowOptions, setShowOptions] = useState(false);
  const years = makeYearList(getYear(new Date()) - 100, getYear(new Date()));

  function makeYearList(start: number, end: number) {
    var arr = [];
    var length = end - start;
    for (var i = 0; i <= length; i++) {
      arr[i] = end;
      end--;
    }
    return arr;
  }

  return (
    <div className={S.year_select_wrap}>
      <button
        type="button"
        onClick={decreaseYear}
        disabled={prevMonthButtonDisabled}
        className="react-datepicker__navigation react-datepicker__navigation--previous"
        aria-label="Previous Month"
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
          Previous Month
        </span>
      </button>
      <div className={S.year_select_box} onClick={() => setShowOptions((prev: boolean) => !prev)}>
        <label className={S.select_label}>{getYear(date)}</label>
        <ul
          className={S.select_option_box}
          style={isShowOptions ? { display: 'block' } : { display: 'none' }}
        >
          {years.map((option: any) => (
            <li
              className={S.select_options}
              onClick={(e: any) => {
                changeYear(Number(e.target.innerText));
              }}
              style={
                option === getYear(date) ? { backgroundColor: '#367c68', color: '#ffffff' } : {}
              }
            >
              {option}
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={increaseYear}
        disabled={nextMonthButtonDisabled}
        className="react-datepicker__navigation react-datepicker__navigation--next"
        aria-label="Next Month"
      >
        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
          Next Month
        </span>
      </button>
    </div>
  );
}
